import React, { useState } from "react";
import { useSettings } from "@/context/SettingsContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Phone, MessageCircle, Mail, MapPin, Clock } from "lucide-react";
import { toast } from "sonner";
import Seo from "@/components/site/Seo";

function mapEmbedSrc(url, address) {
  if (!url) return `https://www.google.com/maps?q=${encodeURIComponent(address || "Bengaluru")}&output=embed`;
  if (url.includes("/maps/embed")) return url;
  try {
    const u = new URL(url);
    const q = u.searchParams.get("query") || u.searchParams.get("q");
    if (q) return `https://www.google.com/maps?q=${encodeURIComponent(q)}&output=embed`;
    const m = url.match(/\/place\/([^/]+)/);
    if (m) return `https://www.google.com/maps?q=${encodeURIComponent(decodeURIComponent(m[1]).replace(/\+/g, " "))}&output=embed`;
  } catch (e) { console.warn("Unparseable maps URL, falling back to address", e); }
  return `https://www.google.com/maps?q=${encodeURIComponent(address || "REXTECH IT SOLUTION Bengaluru")}&output=embed`;
}

export default function Contact() {
  const s = useSettings();
  const [form, setForm] = useState({ customer_name: "", phone: "", email: "", requirements: "" });
  const submit = async () => {
    if (!form.customer_name || !form.phone) return toast.error("Name and phone required");
    try {
      await api.post("/enquiries", { ...form, email: form.email || null, items: [{ product_name: "Contact form message", quantity: 1 }] });
      toast.success("Message sent");
      setForm({ customer_name: "", phone: "", email: "", requirements: "" });
    } catch (e) { console.error("Contact form submit failed", e); toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
  };
  return (
    <div>
      <Seo page="contact"/>
      <div className="bg-[#0F172A] text-white py-10"><div className="container-x"><h1 className="font-heading font-extrabold text-3xl sm:text-4xl">Contact REXTECH</h1></div></div>
      <div className="container-x py-10 grid md:grid-cols-2 gap-8">
        <div className="space-y-4">
          <div className="bg-white border border-[#E2E8F0] rounded-md p-6 space-y-3">
            <div className="flex items-start gap-3"><Phone className="w-5 h-5 text-[#EA580C] mt-1"/><div><div className="font-semibold">Phone</div><div className="text-slate-600">{s.phone_primary} / {s.phone_secondary}</div></div></div>
            <div className="flex items-start gap-3"><MessageCircle className="w-5 h-5 text-[#25D366] mt-1"/><div><div className="font-semibold">WhatsApp</div><a className="text-slate-600" href={`https://wa.me/91${s.whatsapp_primary}`}>{s.whatsapp_primary}</a></div></div>
            <div className="flex items-start gap-3"><Mail className="w-5 h-5 text-[#EA580C] mt-1"/><div><div className="font-semibold">Email</div><div className="text-slate-600">{s.email}</div></div></div>
            <div className="flex items-start gap-3"><MapPin className="w-5 h-5 text-[#EA580C] mt-1"/><div><div className="font-semibold">Address</div><div className="text-slate-600">{s.address}</div></div></div>
            <div className="flex items-start gap-3"><Clock className="w-5 h-5 text-[#EA580C] mt-1"/><div><div className="font-semibold">Hours</div><div className="text-slate-600">{s.business_hours}</div></div></div>
          </div>
          <div className="bg-white border border-[#E2E8F0] rounded-md overflow-hidden" data-testid="contact-map">
            <iframe title="REXTECH location" src={mapEmbedSrc(s.google_maps_url, s.address)} className="w-full h-72 border-0" loading="lazy" allowFullScreen referrerPolicy="no-referrer-when-downgrade"/>
            {s.google_maps_url && <a href={s.google_maps_url} target="_blank" rel="noreferrer" className="block text-center text-sm py-2 text-[#EA580C] font-semibold hover:underline" data-testid="contact-map-link">Open in Google Maps</a>}
          </div>
        </div>
        <div className="bg-white border border-[#E2E8F0] rounded-md p-6 space-y-3">
          <h3 className="font-heading font-bold text-xl">Send us a message</h3>
          <div><Label>Name *</Label><Input value={form.customer_name} onChange={e=>setForm(f=>({...f, customer_name: e.target.value}))}/></div>
          <div><Label>Phone *</Label><Input value={form.phone} onChange={e=>setForm(f=>({...f, phone: e.target.value}))}/></div>
          <div><Label>Email</Label><Input value={form.email} onChange={e=>setForm(f=>({...f, email: e.target.value}))}/></div>
          <div><Label>Message</Label><Textarea rows={4} value={form.requirements} onChange={e=>setForm(f=>({...f, requirements: e.target.value}))}/></div>
          <Button className="btn-orange w-full" onClick={submit}>Send Message</Button>
        </div>
      </div>
    </div>
  );
}
